<div #container class="container">
    @if (content$ | async) {
        <div [hidden]="true"></div>
    }
    @if (marks$ | async) {
        <div [hidden]="true"></div>
    }
    @if (active$ | async) {
        <div #menu class="menu">
            <button mat-flat-button (click)="bold($event)" [color]="isBold ? 'primary' : ''">
                <mat-icon>format_bold</mat-icon>
            </button>
            <button mat-flat-button (click)="italic($event)" [color]="isItalic ? 'primary' : ''">
                <mat-icon>format_italic</mat-icon>
            </button>
            <button
                mat-flat-button
                (click)="bulletList($event)"
                [color]="isBulletedList ? 'primary' : ''"
            >
                <mat-icon>format_list_bulleted</mat-icon>
            </button>
            <button
                mat-flat-button
                (click)="orderedList($event)"
                [color]="isOrderedList ? 'primary' : ''"
            >
                <mat-icon>format_list_numbered</mat-icon>
            </button>
        </div>
    }
    <div
        class="mat-mdc-form-field example-full-width ng-tns-c173-111 mat-mdc-form-field-type-mat-input mat-form-field-appearance-fill mat-form-field-hide-placeholder mat-primary"
    >
        <div class="mat-mdc-text-field-wrapper mdc-text-field mdc-text-field--{{appearance}}">
            <div class="mat-mdc-form-field-flex">
                <div class="mat-mdc-form-field-infix">
                    <div
                        #editor
                        class="mat-mdc-input-element mat-mdc-form-field-textarea-control mat-mdc-form-field-input-control mdc-text-field__input"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</div>
